
import { HuntrixSong } from './types';

export const YOUR_IDOL: HuntrixSong = {
    id: 'YOUR_IDOL',
    title: "Your Idol",
    artist: "HUNTR/X",
    midiFileName: "YourIdol.mid",
    mp3FileName: "YourIdol.mp3",
    sequencedTracks: [
        {
            "name": "Jinu",
            "notes": [
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "8:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "17:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "17:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "17:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "19:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "19:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "19:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "2n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "20:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "23:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "24:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "28:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "41:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "41:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "41:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "43:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "43:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "43:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "2n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "52:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "52:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "52:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "52:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "52:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "60:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "60:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "60:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "61:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "61:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "61:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "61:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "61:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "61:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "62:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "62:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "62:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "63:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "64:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "66:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "67:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "67:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "1m",
                    "time": "68:2:3",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Bass",
            "notes": [
                {
                    "name": "E1",
                    "duration": "2n",
                    "time": "1:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A1",
                    "duration": "2n",
                    "time": "2:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "C2",
                    "duration": "2n",
                    "time": "3:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C2",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "4:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "2n",
                    "time": "5:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A1",
                    "duration": "2n",
                    "time": "6:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "7:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "10:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G1",
                    "duration": "8n",
                    "time": "10:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "13:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "14:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G1",
                    "duration": "8n",
                    "time": "14:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "15:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "4n",
                    "time": "29:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "4n",
                    "time": "30:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "30:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G1",
                    "duration": "8n",
                    "time": "30:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "4n",
                    "time": "31:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A0",
                    "duration": "4n",
                    "time": "32:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "33:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "34:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G1",
                    "duration": "8n",
                    "time": "34:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "35:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "37:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "8n",
                    "time": "38:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "G1",
                    "duration": "8n",
                    "time": "38:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "39:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "2n",
                    "time": "40:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "41:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "1m",
                    "time": "42:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A1",
                    "duration": "1m",
                    "time": "43:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "44:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "52:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "16n",
                    "time": "52:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F#1",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A1",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "60:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "62:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C2",
                    "duration": "2n",
                    "time": "63:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "64:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "64:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "D1",
                    "duration": "1m",
                    "time": "65:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "66:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "C1",
                    "duration": "2n",
                    "time": "67:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "B0",
                    "duration": "2n",
                    "time": "68:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "70:3:3",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "Abby",
            "notes": [
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "9:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "9:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "10:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "10:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "10:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "11:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "11:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "11:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "12:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "12:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "37:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "38:3:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "EDM Kit (E)",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "9:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "11:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "25:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "28:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "29:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "47:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "48:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "49:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "49:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "50:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "50:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "51:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "51:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "51:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "52:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "52:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "53:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "54:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "55:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "57:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "57:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "58:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "58:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "60:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "60:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "60:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "60:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "60:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "62:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "63:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "64:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "64:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "66:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "66:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "67:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "67:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "67:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "67:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "2023 Drum Kit",
            "notes": [
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "2n",
                    "time": "9:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "9:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:2:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "10:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "11:3:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "2n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "25:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "26:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "27:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:4",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "49:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "50:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "51:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "53:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "53:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "53:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "53:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "53:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "54:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "54:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "54:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "54:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "54:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "55:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "55:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "56:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "57:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "57:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "57:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "57:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "57:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "58:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "58:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "58:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "58:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "60:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#3",
                    "duration": "2n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "62:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "68:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "68:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Church Organ",
            "notes": [
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "6:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "6:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "7:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "62:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "62:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "62:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "62:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "62:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "62:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "62:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "62:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "64:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "64:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "65:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "65:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "66:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "66:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "66:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "66:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "66:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "66:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "66:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "67:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "68:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "68:2:2",
                    "velocity": 0.2
                }
            ]
        },
        {
            "name": "Lucent Choir",
            "notes": [
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "9:0:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "9:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "9:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "9:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "10:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "F#1",
                    "duration": "4n",
                    "time": "10:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "G1",
                    "duration": "4n",
                    "time": "10:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "11:0:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "11:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "11:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "11:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "12:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "F#1",
                    "duration": "4n",
                    "time": "12:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "G1",
                    "duration": "4n",
                    "time": "12:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "33:0:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "33:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "33:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "33:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "34:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "F#1",
                    "duration": "4n",
                    "time": "34:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "G1",
                    "duration": "4n",
                    "time": "34:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "4n",
                    "time": "35:0:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "35:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "C2",
                    "duration": "4n",
                    "time": "35:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "B1",
                    "duration": "2n",
                    "time": "35:3:0",
                    "velocity": 0.04
                },
                {
                    "name": "A1",
                    "duration": "4n",
                    "time": "36:1:0",
                    "velocity": 0.04
                },
                {
                    "name": "F#1",
                    "duration": "4n",
                    "time": "36:2:0",
                    "velocity": 0.04
                },
                {
                    "name": "G1",
                    "duration": "4n",
                    "time": "36:3:0",
                    "velocity": 0.04
                }
            ]
        },
        {
            "name": "Choir Chants",
            "notes": [
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "0:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "0:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "0:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "0:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "0:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "0:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "0:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "0:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "0:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "1:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "1:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "1:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "1:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "1:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "1:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "1:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "1:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "1:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "1:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "1:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "1:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "2:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "3:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "3:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "3:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "3:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "4:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "5:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "5:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "6:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "6:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "6:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "7:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "7:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "7:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "8:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "21:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "21:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "21:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "21:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "21:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "22:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "22:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "22:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "22:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "23:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "23:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "23:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "23:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "24:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "24:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "24:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "27:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "28:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "28:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "28:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "28:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "45:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "45:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "45:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "45:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "45:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "45:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "45:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "46:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "46:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "46:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "46:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "47:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "47:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "47:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "47:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "47:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "47:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "48:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "48:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "48:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "51:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "51:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "52:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "52:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "59:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "64:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "64:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "64:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "64:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "64:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "65:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "66:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "66:3:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "66:3:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "67:1:2",
                    "velocity": 0.31
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "67:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "67:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "67:2:2",
                    "velocity": 0.31
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "67:2:2",
                    "velocity": 0.31
                }
            ]
        },
        {
            "name": "2023 Drum Kit (Alt)",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "17:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "19:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C#3",
                    "duration": "2n",
                    "time": "21:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "F3",
                    "duration": "2n",
                    "time": "29:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "44:0:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "44:1:2",
                    "velocity": 0.27
                },
                {
                    "name": "A#1",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.27
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.27
                },
                {
                    "name": "C#3",
                    "duration": "2n",
                    "time": "45:0:0",
                    "velocity": 0.27
                }
            ]
        },
        {
            "name": "Cello",
            "notes": [
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "27:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "16n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C2",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G1",
                    "duration": "16n",
                    "time": "51:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "51:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Violin",
            "notes": [
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "59:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#5",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Baby",
            "notes": [
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "33:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "36:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "36:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Square",
            "notes": [
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E0",
                    "duration": "8n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E0",
                    "duration": "16n",
                    "time": "53:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "53:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E0",
                    "duration": "16n",
                    "time": "53:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F1",
                    "duration": "8n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "8n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F1",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "16n",
                    "time": "54:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F1",
                    "duration": "16n",
                    "time": "54:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "16n",
                    "time": "54:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "8n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E0",
                    "duration": "8n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E0",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E1",
                    "duration": "16n",
                    "time": "55:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E0",
                    "duration": "16n",
                    "time": "55:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F1",
                    "duration": "8n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "8n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F1",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F1",
                    "duration": "16n",
                    "time": "56:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "16n",
                    "time": "56:1:3",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "8-Bit Sine",
            "notes": [
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "56:3:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Brass",
            "notes": [
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "53:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "53:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "53:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "54:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "54:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "54:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "54:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "55:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "55:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "55:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "55:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "56:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "56:1:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "2013 Drum Kit",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:2:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:3:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "55:3:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:0:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:0:1",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:0:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:0:3",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:1:0",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:1:1",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:1:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "56:1:3",
                    "velocity": 0.16
                }
            ]
        },
        {
            "name": "Smooth Synth",
            "notes": [
                {
                    "name": "E1",
                    "duration": "1m",
                    "time": "17:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#1",
                    "duration": "1m",
                    "time": "18:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "C1",
                    "duration": "1m",
                    "time": "19:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B0",
                    "duration": "2n",
                    "time": "20:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "E0",
                    "duration": "1m",
                    "time": "57:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "F#0",
                    "duration": "1m",
                    "time": "58:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "A0",
                    "duration": "1m",
                    "time": "59:0:0",
                    "velocity": 0.12
                },
                {
                    "name": "B0",
                    "duration": "2n",
                    "time": "60:0:0",
                    "velocity": 0.12
                }
            ]
        },
        {
            "name": "Violin (Classic)",
            "notes": [
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "24:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "25:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "28:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "32:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "49:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "49:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "50:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "50:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "52:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "52:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "52:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "57:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "58:3:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Riser",
            "notes": [
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "8:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "20:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "28:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "2n",
                    "time": "44:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "68:2:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "808 Drum Kit",
            "notes": [
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "9:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "9:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "10:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "10:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "11:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "12:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "13:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "14:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "15:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "15:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "29:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "29:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "30:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "30:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "31:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "31:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "32:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "53:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "54:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "54:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "55:1:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "55:3:0",
                    "velocity": 0.43
                },
                {
                    "name": "D#2",
                    "duration": "8n",
                    "time": "56:1:0",
                    "velocity": 0.43
                }
            ]
        },
        {
            "name": "808 Bass",
            "notes": [
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "1:0:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Romance",
            "notes": [
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "13:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "25:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "25:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "26:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "26:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "26:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "27:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "4n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "49:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "49:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "49:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "49:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "49:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "50:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "50:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "50:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "50:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "50:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "50:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "50:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "51:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "51:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "51:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "51:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Electric Piano (All)",
            "notes": [
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "1:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "1:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "1:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "1:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "2:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "2:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "3:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "3:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "3:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "3:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "3:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "3:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "3:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "2n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "4:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "5:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "5:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "5:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "5:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "6:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "6:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "7:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "7:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "7:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "7:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "1m",
                    "time": "7:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "8:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "8:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "8:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "8:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "9:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "10:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "11:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "12:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "12:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B1",
                    "duration": "8n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D2",
                    "duration": "8n",
                    "time": "17:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "17:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "17:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "19:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "19:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "19:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "19:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "19:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "19:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "19:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "20:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "22:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "22:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "23:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "24:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "24:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "24:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "24:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "24:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "24:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "25:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "25:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "25:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "25:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "25:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "25:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "25:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "26:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "26:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "26:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "26:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "26:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "27:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "27:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "27:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "28:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "28:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "28:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "28:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "28:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "38:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "8n",
                    "time": "41:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "41:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "41:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "2n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "43:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "43:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "43:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "43:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "43:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "43:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "43:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "2n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "2n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "2n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "46:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "48:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "48:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "48:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "48:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "48:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "48:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "48:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "49:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "49:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "49:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "49:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "49:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "49:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "49:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "49:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "49:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "50:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "50:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "50:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "50:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "50:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "50:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "51:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "51:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "51:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "51:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "52:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "52:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "52:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "52:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "52:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "52:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "52:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "52:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "52:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "56:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "56:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "8n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "56:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "57:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "57:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "57:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "57:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "57:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "57:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "57:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "57:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "4n",
                    "time": "57:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "57:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "E2",
                    "duration": "8n",
                    "time": "57:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "58:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "16n",
                    "time": "58:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "58:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "58:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "58:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "16n",
                    "time": "58:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "58:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G2",
                    "duration": "8n",
                    "time": "58:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "4n",
                    "time": "58:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A2",
                    "duration": "8n",
                    "time": "58:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "59:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "59:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "59:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "59:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "4n",
                    "time": "59:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "59:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "59:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "60:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "60:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "8n",
                    "time": "60:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "60:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "60:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "60:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "60:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "60:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "60:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "60:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "60:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "60:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "60:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#4",
                    "duration": "16n",
                    "time": "60:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "60:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "61:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "61:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "61:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "61:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "61:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "61:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G4",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B4",
                    "duration": "4n",
                    "time": "61:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "61:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "61:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "61:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "61:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "62:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "62:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "62:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "62:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "62:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "62:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "62:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "4n",
                    "time": "62:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "63:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "63:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "63:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "63:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "63:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "63:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "63:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "64:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "64:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "64:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "64:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "64:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "65:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "65:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "65:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "65:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "65:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "65:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "66:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "66:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "66:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "66:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "66:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "66:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "66:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "66:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "66:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E4",
                    "duration": "4n",
                    "time": "66:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "67:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "67:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "67:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "67:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "67:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "68:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "68:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "68:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "68:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "8n",
                    "time": "68:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "1m",
                    "time": "68:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "1m",
                    "time": "68:2:3",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Mystery",
            "notes": [
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.39
                }
            ]
        }
    ],
    structure: [
        { type: 'INTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["(Your Idol...)", "Eyes on me.", "Don't look away."] },
        { type: 'VERSE', duration: 32, rhythm: 'TRAP', lyrics: ["Keeping you in check, keeping you obsessed", "Play me on repeat, endlessly in your head", "Anytime it hurts, play another verse", "I can be your sanctuary, your universe"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["I'm the only one who'll love your sins", "Feel the way my voice gets underneath your skin", "Close your eyes and let the dream begin"] },
        { type: 'CHORUS', duration: 32, rhythm: 'HOUSE', lyrics: ["Listen 'cause I'm preachin' to the choir", "Can I get the mic a little higher?", "Gimme your desire, I can be the star you rely on", "Yeah, I'm all you need, I'ma be your idol"] },
        { type: 'VERSE', duration: 32, rhythm: 'TRAP', lyrics: ["Know I'm the only one right now", "I will love you more when it all burns down", "More than power, more than gold", "Yeah, you gave me your heart, now I'm here for your soul"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["I'm the only one who'll love your sins", "Feel the way my voice gets underneath your skin", "Close your eyes and let the dream begin"] },
        { type: 'CHORUS', duration: 32, rhythm: 'HOUSE', lyrics: ["You're lost in my daze, yeah, you can't look away", "Don't you know I'm here to save you?", "Now we runnin' wild", "Yeah, I'm all you need, I'ma be your idol"] },
        { type: 'BRIDGE', duration: 16, rhythm: 'MINIMAL', lyrics: ["Worship at the altar of the sound", "Feet never touching the ground", "Lost and found...", "I am your Idol."] },
        { type: 'DROP', duration: 16, rhythm: 'TRAP', lyrics: ["(IDOL!)", "Look at me!", "(IDOL!)", "Forever!"] },
        { type: 'CHORUS', duration: 32, rhythm: 'HOUSE', lyrics: ["Listen 'cause I'm preachin' to the choir", "Can I get the mic a little higher?", "Gimme your desire, I can be the star you rely on", "Yeah, I'm all you need, I'ma be your idol"] },
        { type: 'OUTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["Your Idol.", "Just for you.", "Only you."] }
    ],
    musicalData: {
        keyRoot: "E",
        scale: "minor",
        bpm: 120,
        defaultTheme: {
            chordProgression: [0, 5, 2, 6],
            bassPattern: [1, 0, 0, 1, 0, 0, 1, 0],
            melodyPattern: [0, 3, 2, 0, null, 0, null, 0]
        },
        themes: {
            INTRO: {
                chordProgression: [0, 0, 5, 5],
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0], // Long sustain
                // Haunting piano arpeggio
                melodyPattern: [12, 7, 0, 7, 12, 14, 15, 14, 12, 7, 0, 7, 12, null, null, null]
            },
            VERSE: {
                chordProgression: [0, 5], // i - VI
                bassPattern: [1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 0], // Trap feel
                melodyPattern: [0, 0, 0, 2, 0, null, null, 0, 0, 0, 0, 2, 0, null, 3, 2]
            },
            PRE_CHORUS: {
                chordProgression: [2, 6, 0, 4], // III - VII - i - V
                bassPattern: [1, 1, 1, 1, 1, 1, 1, 1],
                melodyPattern: [4, 4, 5, 5, 7, 7, 9, 9, 7, 7, 5, 5, 4, 4, 2, 0]
            },
            CHORUS: {
                chordProgression: [5, 0, 2, 6], // VI - i - III - VII
                bassPattern: [1, 0, 1, 1, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 1, 1], // Heavy
                melodyPattern: [7, 7, 7, 12, 0, 12, 7, 5, 4, 4, 4, 5, 7, null, 7, 7]
            },
            BRIDGE: {
                chordProgression: [5, 4, 3, 4], // vi - V - IV - V
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0],
                melodyPattern: [12, null, 11, null, 9, null, 7, null, 5, 4, 2, 0, 2, 4, 7, 12]
            },
            DROP: {
                chordProgression: [0, 5, 0, 6],
                bassPattern: [1, 0, 1, 0, 1, 0, 1, 1],
                melodyPattern: [0, 12, 0, 15, 0, 12, 0, 7, 0, 12, 0, 15, 0, 19, 19, 19]
            }
        }
    }
};
